import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { DisabledOnWorkingDirective } from './disabled-on-working/disabled-on-working.directive';
import { NullWithDefaultPipe } from './null-with-default.pipe';
import { ErrorService } from './services/error.service';
import { TextNotificationService } from './services/text-notification.service';
import { SnackMessageComponent } from './snack-message/snack-message.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';


@NgModule({
  declarations: [
    NullWithDefaultPipe,
    SnackMessageComponent,
    DisabledOnWorkingDirective
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatSnackBarModule
  ],
  exports: [
    NullWithDefaultPipe,
    DisabledOnWorkingDirective
  ],
  providers: [
    TextNotificationService,
    ErrorService
  ]
})
export class CommonAppModule { }
